import BoxItem from '../item/boxItem';
import FoamItem from '../item/foamItem';
import GridItem from '../item/gridItem';
import PhotoMountItem from '../item/photoMountItem';
import TabletopItem from '../item/tabletopItem';
import BoxItemEnvironment from './boxItemEnvironment';
import FoamItemEnvironment from './foamItemEnvironment';
import GridItemEnvironment from './gridItemEnvironment';
import PhotoMountItemEnvironment from './photoMountItemEnvironment';
import TabletopItemEnvironment from './tabletopItemEnvironment';

/**
 * @class ItemEnvironmentFactory
 */
export default class ItemEnvironmentFactory {
    /**
     * @param {Pimple} container
     */
    constructor(container) {
        this.container = container;
    }

    /**
     * Create an environment for the given item
     *
     * @param {AbstractItem} item
     * @return {ItemEnvironmentInterface}
     */
    createEnvironment(item) {
        if (item instanceof FoamItem) {
            return new FoamItemEnvironment(item, this.container);
        }

        if (item instanceof BoxItem) {
            return new BoxItemEnvironment(item, this.container);
        }

        if (item instanceof GridItem) {
            return new GridItemEnvironment(item, this.container);
        }

        if (item instanceof PhotoMountItem) {
            return new PhotoMountItemEnvironment(item, this.container);
        }

        if (item instanceof TabletopItem) {
            return new TabletopItemEnvironment(item, this.container);
        }

        return null;
    }
}
